import ManagementSnContainer from "./management-sn.container";

export default ManagementSnContainer;
